import { Component } from 'react';
import './App.css';
import toast, { Toaster } from 'react-hot-toast';
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "./Redux/Actions/userAction";
import Content from "./views/content/Content";
import Login from "./views/login/Login";
import User from "./views/user/User";
import {
  screenStatusActive,
  screenStatusDeActive,
} from "./Redux/Actions/screenAction";
import Screen from "./views/screen/Screen";
import Playlist from "./views/playlist/Playlist";
import ForgetPassword from "./views/login/ForgetPassword";
import Dashboard from "./views/dashboard/Dashboard";
import Setting from "./views/setting/Setting";
import Store from "./views/store/Store";
import StorePortal from "./views/storeportal/StorePortal";
import TLJ from "./views/tlj/TLJ";
import StoreForm from "./views/storeform/StoreForm";
import MenuForm from "./views/menuform/MenuForm";
import MenuMaster from "./views/menuMaster/MenuMaster";
import TvRemote from "./views/tvRemote/TvRemote";
import SeasonalMenu from "./views/seasonalmenu/SeasonalMenu";
import SeasonalConfirm from "./views/seasonalmenu/SeasonalConfirm";
import Payment from "./views/payment/Payment";
import DevicesHub from "./views/devices/DevicesHub";
import DeviceDetail from "./views/devices/DeviceDetail";
import OnboardingBoard from "./views/onboarding/OnboardingBoard";
import JoinStore from "./views/join/JoinStore";
import SignupGuide from "./views/join/SignupGuide";
import Requests from "./views/requests/Requests";
import ServiceRequestHub from "./views/service-requests/ServiceRequestHub";
import { features } from "./config/features";
import { canAccess, redirectFor } from "./config/navigation";
import StorePricing from "./views/pricing/StorePricing";
import InvoiceDashboard from "./views/invoices/InvoiceDashboard";
import StoreRegister from "./views/login/StoreRegister";
import ContractSign from "./views/contract/ContractSign";
import ContractRenewal from "./views/contract/ContractRenewal";
import ProviderSign from "./views/contract/ProviderSign";
import CustomerIntake from "./views/intake/CustomerIntake";
import EmailRegister from "./views/login/EmailRegister";
import ActivityLog from "./views/activitylog/ActivityLog";
import AdminSettings from "./views/admin/AdminSettings";
import QuickSetup from "./views/quicksetup/QuickSetup";
import FieldKitReports from "./views/fieldkit/FieldKitReports";
import MenuBoardEditor from "./views/menuboard/MenuBoardEditor";
import SeasonalProducts from "./views/seasonal/SeasonalProducts";
import socket, { setSocketAuth } from './socket';
import ChatWidget from './components/chat/ChatWidget';
import { api } from './api/api';
import PrivacyPolicy from './views/privacypolicy/PrivacyPolicy';
import Activate from './views/activate/Activate';
import ChangePassword from './views/login/ChangePassword';
import SetPassword from './views/login/SetPassword';
import {useRefreshLogin} from './hooks/useRefreshLogin';
import { Box } from '@mui/material';
import loginBackgroundIMG from "./Assets/images/login-background.png";
const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

function App() {
  const dispatch = useDispatch();
  const { user ,auth} = useSelector((state) => state.User);
  useRefreshLogin();

  /** 5분 무활동 로그아웃 — ref 기반으로 deps 체인 제거 (플리커링 방지) */
  const idleTimerRef = useRef(null);
  const dispatchRef = useRef(dispatch);
  dispatchRef.current = dispatch;

  useEffect(() => {
    const reset = () => { if (idleTimerRef.current) { clearTimeout(idleTimerRef.current); idleTimerRef.current = null; } };
    const schedule = () => { reset(); idleTimerRef.current = setTimeout(() => { reset(); dispatchRef.current(logout()); }, 30 * 60 * 1000); };
    events.forEach((evt) => window.addEventListener(evt, schedule));
    schedule();
    return () => { events.forEach((evt) => window.removeEventListener(evt, schedule)); reset(); };
  }, []);


  // 로그인 후 소켓에 JWT 인증 적용 (admin 명령 활성화)
  useEffect(() => {
    if (!auth) return;
    api.get('/user/socket-token').then(res => {
      if (res.data?.token) setSocketAuth(res.data.token);
    }).catch(() => {});
  }, [auth]);

  const socketRef = useRef();
  const dispatchSocketRef = useRef(dispatch);
  dispatchSocketRef.current = dispatch;
  useEffect(() => {
    socketRef.current = socket;

    const onScreen = (data) => { console.log('[socket] screen', data); };
    const onMessage = ({ message }) => { if (message) toast.success('message successfully'); };
    // 소켓 이벤트 스로틀 — 동일 mac에 대해 10초 이내 중복 호출 방지
    const lastStatusUpdate = {};
    const THROTTLE_MS = 10000;
    const onAdminScreen = ({ detail }) => {
      const now = Date.now();
      const key = `active_${detail.mac}`;
      if (lastStatusUpdate[key] && now - lastStatusUpdate[key] < THROTTLE_MS) return;
      lastStatusUpdate[key] = now;
      dispatchSocketRef.current(screenStatusActive(detail.mac, true));
    };
    const onLeave = (obj) => {
      const now = Date.now();
      const key = `leave_${obj.mac}`;
      if (lastStatusUpdate[key] && now - lastStatusUpdate[key] < THROTTLE_MS) return;
      lastStatusUpdate[key] = now;
      dispatchSocketRef.current(screenStatusDeActive(obj.mac, false));
    };

    socketRef.current.on("screen", onScreen);
    socketRef.current.on("message_recieved", onMessage);
    socketRef.current.on("admin_screen", onAdminScreen);
    socketRef.current.on("leave", onLeave);

    return () => {
      socketRef.current.off("screen", onScreen);
      socketRef.current.off("message_recieved", onMessage);
      socketRef.current.off("admin_screen", onAdminScreen);
      socketRef.current.off("leave", onLeave);
    };
  }, []);
  return (
    <div className="App">
    <Toaster
      position={"top-right"}
      toastOptions={{
        duration: 3000,
      }}
    />
    <BrowserRouter>
      <Routes>
        <Route exact path={"/changepassword/:id/:token"} element={<ChangePassword/>} />
        <Route exact path={"/setpassword/:id/:token"} element={<SetPassword/>} />
        <Route exact path={"/store-form/:token"} element={<StoreForm />} />
        <Route exact path={"/menu-form/:token"} element={<MenuForm />} />
        <Route exact path={"/forgetpassword"} element={<ForgetPassword />} />
        <Route exact path={'/privacypolicy'} element={<PrivacyPolicy/>}/>
        <Route exact path={"/login"} element={<Login />} />
        <Route exact path={"/register"} element={<StoreRegister />} />
        <Route exact path={"/register-email"} element={<EmailRegister />} />
        <Route exact path={"/join/:token"} element={<JoinStore />} />
        <Route exact path={"/signup-guide"} element={<SignupGuide />} />
        <Route exact path={"/contract-sign/:userId/:token"} element={<ContractSign />} />
        <Route exact path={"/contract-renewal/:storeId/:token"} element={<ContractRenewal />} />
        <Route exact path={"/provider-sign/:token"} element={<ProviderSign />} />
        <Route exact path={"/customer-intake/:token"} element={<CustomerIntake />} />
        <Route exact path={"/seasonal-confirm/:token"} element={<SeasonalConfirm />} />
        <Route exact path={"/activate"} element={<Activate />} />
        <Route element={<PrivateRouter/>}>
          <Route element={<RoleRoute/>}>
          <Route
            exact
            path={"/"}
            element={<Dashboard user={user} />}
          />
          <Route
            exact
            path={"/content"}
            element={<Content user={user} socketRef={socketRef} />}
          />
          <Route exact path={"/user"} element={<User user={user} socketRef={socketRef} />} />
          <Route
            exact
            path={"/screen"}
            element={<Screen user={user} socketRef={socketRef} />}
          />
          <Route
            exact
            path={"/playlist"}
            element={<Playlist user={user} socketRef={socketRef} />}
          />
          <Route
            exact
            path={"/setting/:id"}
            element={<Setting user={user} socketRef={socketRef} />}
          />
          <Route
            exact
            path={"/store"}
            element={<Store user={user} socketRef={socketRef} />}
          />
          <Route
            exact
            path={"/seasonal"}
            element={<SeasonalMenu user={user} />}
          />
          <Route
            exact
            path={"/payment"}
            element={<Payment user={user} />}
          />
          <Route
            exact
            path={"/storeportal"}
            element={<StorePortal user={user} />}
          />
          <Route
            exact
            path={"/tlj"}
            element={<TLJ user={user} />}
          />
          <Route
            exact
            path={"/provisioning"}
            element={<Navigate to="/devices?tab=wg" replace />}
          />
          <Route
            exact
            path={"/menu-master"}
            element={<MenuMaster user={user} />}
          />
          <Route
            exact
            path={"/tv-remote"}
            element={<TvRemote user={user} />}
          />
          <Route
            exact
            path={"/onboarding"}
            element={<OnboardingBoard user={user} />}
          />
          <Route
            exact
            path={"/devices"}
            element={<DevicesHub user={user} />}
          />
          <Route
            path={"/devices/:code"}
            element={<DeviceDetail user={user} />}
          />
          <Route
            exact
            path={"/device-hub"}
            element={<Navigate to="/devices?tab=commands" replace />}
          />
          <Route
            exact
            path={"/health"}
            element={<Navigate to="/devices?tab=health" replace />}
          />
          <Route
            exact
            path={"/requests"}
            element={<Requests user={user} />}
          />
          <Route
            exact
            path={"/service-requests"}
            element={<ServiceRequestHub user={user} />}
          />
          <Route
            exact
            path={"/pricing/:storeId"}
            element={<StorePricing user={user} />}
          />
          <Route
            exact
            path={"/invoices"}
            element={<InvoiceDashboard user={user} />}
          />
          <Route
            exact
            path={"/quick-setup"}
            element={<QuickSetup user={user} />}
          />
          <Route
            exact
            path={"/field-visits"}
            element={<FieldKitReports user={user} />}
          />
          <Route exact path={"/menu-board"} element={<MenuBoardEditor />} />
          <Route exact path={"/menu-board/:storeId"} element={<MenuBoardEditor />} />
          <Route
            exact
            path={"/activity-log"}
            element={<ActivityLog user={user} />}
          />
          <Route
            exact
            path={"/admin-settings"}
            element={<AdminSettings user={user} />}
          />
          <Route
            exact
            path={"/seasonal-products"}
            element={<SeasonalProducts user={user} />}
          />
          </Route>{/* RoleRoute */}
        </Route>{/* PrivateRouter */}
      </Routes>
      {auth && <ChatWidget user={user} />}
    </BrowserRouter>
  </div>
  );
}
function PrivateRouter() {
  const { auth, sessionHydrated } = useSelector((state) => state.User);
  const location = useLocation();
  if (!sessionHydrated) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#f8f9fa',
        }}
      >
        <Box sx={{ width: 36, height: 36, border: '3px solid #e5e7eb', borderTopColor: '#551FFF', borderRadius: '50%', animation: 'spin 0.8s linear infinite', '@keyframes spin': { to: { transform: 'rotate(360deg)' } } }} />
        <Box sx={{ mt: 2, fontSize: 13, color: '#888', fontFamily: 'sans-serif' }}>Loading...</Box>
      </Box>
    );
  }
  // 로그인 후 원래 가려던 화면으로 (메일 링크 → 로그인 → 그 화면)
  return auth ? <Outlet /> : <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
}

// 역할별 접근 허용 — src/config/navigation.js (메뉴와 같은 설정)
function RoleRoute() {
  const { user } = useSelector((state) => state.User);
  const { pathname } = useLocation();
  if (canAccess(user?.role, pathname, features)) return <Outlet />;
  return <Navigate to={redirectFor(pathname, features)} replace />;
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh', fontFamily: 'sans-serif',
          background: '#f8f7ff', color: '#333', padding: 32,
        }}>
          <h2 style={{ color: '#551FFF', marginBottom: 16 }}>페이지를 불러오는 중 오류가 발생했습니다</h2>
          <pre style={{
            background: '#fff', border: '1px solid #ddd', borderRadius: 8,
            padding: 16, maxWidth: 600, overflow: 'auto', fontSize: 13,
          }}>
            {this.state.error?.toString()}
          </pre>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 24, padding: '10px 24px', background: '#551FFF',
              color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer',
              fontSize: 15,
            }}
          >
            새로고침
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function AppWithErrorBoundary() {
  return (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}

export default AppWithErrorBoundary;
